import { PapiDeviation } from '@wix/da-papi-types';
import { getIsAdoptableOfferType, getIsOnSale, getIsPending } from '../../../utils/adoptables';
import type { ElementGroup } from '../types';

/**
 * An element group shown to an adoptable's author. This doesn't include controls for the initial listing
 * of a deviation as an adoptable, though.
 */
export interface BaseAdoptableSellerElementGroup<
  ElementPlacementType,
  ElementGroupPlacementsType extends ElementPlacementType,
> extends ElementGroup<ElementPlacementType> {
  groupPlacement: ElementGroupPlacementsType;
  endSale?: boolean;
  viewOffers?: boolean;
}

export function getAdoptableSellerElementGroupBase<
  ElementPlacementType,
  ElementGroupPlacementsType extends ElementPlacementType,
>(deviation: PapiDeviation, isMobile: boolean, isOwner: boolean) {
  if (!deviation.isAdoptable || isMobile) {
    return false;
  }

  const isPending = getIsPending(deviation);
  const isOnSale = getIsOnSale(deviation);

  if (
    // Can't edit a deviation's adoptable sale settings if it isn't on sale
    (!isPending && !isOnSale) ||
    // Only the current owner can edit an ongoing sale
    !isOwner
  ) {
    return false;
  }
  const isOfferType = getIsAdoptableOfferType(deviation);

  const result: Required<
    Omit<
      BaseAdoptableSellerElementGroup<ElementPlacementType, ElementGroupPlacementsType>,
      'countOnBar' | 'groupPlacement'
    >
  > = {
    endSale: true,
    viewOffers: isOfferType,
  };

  return result;
}
